import { render, staticRenderFns } from "./goals.vue?vue&type=template&id=5af3f4d9"
import script from "./goals.vue?vue&type=script&lang=js"
export * from "./goals.vue?vue&type=script&lang=js"
import style0 from "./goals.vue?vue&type=style&index=0&id=5af3f4d9&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports